import {useEffect, useState} from 'react';

export function useDebounce(value, delay = 300) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => setDebounced(value), delay);
        return () => window.clearTimeout(timeoutId);
    }, [delay, value]);

    return debounced;
}
